import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React from 'react'
import CMSText from '../Global/CMSText'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'block',
      height: 200,
      border: `1px solid ${theme.palette.primary.main}`,
      textAlign: 'justify',
      overflowY: 'scroll',
      margin: theme.spacing(1),
      padding: theme.spacing(1),
    },
  })
)

type Tprops = {
  text: any[]
}

const TextBox = ({ text }: Tprops) => {
  const classes = useStyles()
  return (
    <>
      {text && text.length > 0 && (
        <div className={classes.root}>
          <CMSText data={text} />
        </div>
      )}
    </>
  )
}

export default TextBox
